import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-2xl mb-8 md:mb-10">
          <span className="text-xs font-medium text-primary-600 tracking-widest">
            VOICES / 读者怎么说
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            他们用瓜田爆料的方式看话题
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            没有夸张的标题，也不必在信息流里翻找。分类与分区浏览，是读者提到最多的两个字。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700 flex-1">
                {item.quote}
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-background-100 flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-secondary-100 text-secondary-800 flex items-center justify-center text-sm font-semibold">
                  {item.initial}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                  <span className="block text-xs text-foreground-500 mt-0.5">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}